import { hashHistory } from 'react-router';

// All paths
const PATHS = {
  MORE: 'more',
  CONTACT_US: 'contact_us',
  FAQ: 'faq',
  HOW_IT_WORKS: 'how_it_works',
  TERMS_OF_SERVICE: 'terms_of_service',
};

// Exported paths
export const MAIN_PATH = PATHS.MORE;
export const CONTACT_US_PATH = PATHS.CONTACT_US;
export const FAQ_PATH = PATHS.FAQ;
export const HOW_IT_WORKS_PATH = PATHS.HOW_IT_WORKS;
export const TERMS_OF_SERVICE_PATH = PATHS.TERMS_OF_SERVICE;

export const contactUsPath = () => `${MAIN_PATH}/${CONTACT_US_PATH}`;
export const navigateToContactUs = () => {
  hashHistory.push(contactUsPath());
};

export const faqPath = () => `${MAIN_PATH}/${FAQ_PATH}`;
export const navigateToFaq = () => {
  hashHistory.push(faqPath());
};

export const howItWorksPath = () => `${MAIN_PATH}/${HOW_IT_WORKS_PATH}`;
export const navigateToHowItWorks = () => {
  hashHistory.push(howItWorksPath());
};

export const termsOfServicePath = () => `${MAIN_PATH}/${TERMS_OF_SERVICE_PATH}`;
export const navigateToTermsOfService = () => {
  hashHistory.push(termsOfServicePath());
};



// WEBPACK FOOTER //
// ./routes/more/navigation.js